// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"38":"css/spectrum","252":"css/app"}[chunkId] + ".css";
};